import { all } from 'redux-saga/effects/';

// global store
import reviewSaga from 'src/store/reviews/sagas';
import experimentSaga from 'src/store/experimentStats/saga';
import mindboxAnalytics from 'src/store/mindbox/sagas';
import appBannersSagaWatcher from 'src/store/appBannerStats/saga';
import cashbackSaga from 'src/store/cashback/saga';
import client from '../../../../store/client/sagas';
import globalView from '../../../../store/view/sagas';
import globalAnalytics from '../../../../store/analytics/sagas';
import wishlist from '../../../../store/wishlist/sagas';
import bannerAppData from '../../../../store/appBanners/sagas';

import view from './view';
import searcher from './searcher';
import windowSaga from './window';
import map from './map';
import offer from './offer';
import analytics from './analytics';

import { isSSR } from '../../../../helpers/ssr';
import {
  closestDatesAnalyticsWatcher,
  closestDatesWatcher,
} from '../closestDates';

function* sagas() {
  const availableWithSsrSagas = [
    client(),
    globalView(),
    globalAnalytics(),
    mindboxAnalytics(),
    wishlist(),
    //
    view(),
    searcher(),
    offer(),
    map(),
    bannerAppData(),
    appBannersSagaWatcher(),
    closestDatesWatcher(),
    closestDatesAnalyticsWatcher(),
    cashbackSaga(),
  ];

  const onlyClientSagas = [
    windowSaga(),
    analytics(),
    reviewSaga(),
    experimentSaga(),
  ];

  const prepareSagas = isSSR
    ? availableWithSsrSagas
    : [...availableWithSsrSagas, ...onlyClientSagas];

  yield all(prepareSagas);
}

export default sagas;
